import { createUseStyles } from 'react-jss'

const styles = {
  layer: {
    cursor: 'zoom-in',
    strokeWidth: 0.6
  }
}

export const useStyles = createUseStyles(styles)
